import { getInitialState, getEndState, startQuery, accEvents, reflectSpan } from './reducer-utils'
import { LollipopState, LollipopEvent } from './types'

export const lollipopReducer: WidgetReducerType<LollipopState, FlowMessage<LiveEvent<LollipopEvent>>> = (
    state = getInitialState(),
    action
) => {
    switch (action?.type) {
        case 'start':
            return startQuery(action, state)

        case 'event':
            return accEvents(action, state)

        case 'endHistory':
            return getEndState(state)

        case 'span':
            return reflectSpan(action, state)

        default:
            return state
    }
}
